import React, { useState, useEffect, useRef } from "react";
// import "./StockPanel.css";

const data = [
  { symbol: "500", price: 687, change: 43.9, percent: 0.64 },
  { symbol: "100", price: 254, change: 115, percent: 0.46 },
  { symbol: "V", price: 14.1, change: 0.02, percent: 0.14 },
  { symbol: "D1", price: 55, change: 1.5, percent: 2.8 },
  { symbol: "D2", price: 45.2, change: 0.75, percent: 1.69 },
  { symbol: "D3", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "AAPL", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "500", price: 687, change: 43.9, percent: 0.64 },
  { symbol: "100", price: 254, change: 115, percent: 0.46 },
  { symbol: "V", price: 14.1, change: 0.02, percent: 0.14 },
  { symbol: "D1", price: 55, change: 1.5, percent: 2.8 },
  { symbol: "D2", price: 45.2, change: 0.75, percent: 1.69 },
  { symbol: "D3", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "AAPL", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "aa", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "bb", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "500", price: 687, change: 43.9, percent: 0.64 },
  { symbol: "100", price: 254, change: 115, percent: 0.46 },
  { symbol: "V", price: 14.1, change: 0.02, percent: 0.14 },
  { symbol: "D1", price: 55, change: 1.5, percent: 2.8 },
  { symbol: "D2", price: 45.2, change: 0.75, percent: 1.69 },
  { symbol: "D3", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "AAPL", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "500", price: 687, change: 43.9, percent: 0.64 },
  { symbol: "100", price: 254, change: 115, percent: 0.46 },
  { symbol: "V", price: 14.1, change: 0.02, percent: 0.14 },
  { symbol: "D1", price: 55, change: 1.5, percent: 2.8 },
  { symbol: "D2", price: 45.2, change: 0.75, percent: 1.69 },
  { symbol: "D3", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "AAPL", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "aa", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "bb", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "500", price: 687, change: 43.9, percent: 0.64 },
  { symbol: "100", price: 254, change: 115, percent: 0.46 },
  { symbol: "V", price: 14.1, change: 0.02, percent: 0.14 },
  { symbol: "D1", price: 55, change: 1.5, percent: 2.8 },
  { symbol: "D2", price: 45.2, change: 0.75, percent: 1.69 },
  { symbol: "D3", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "AAPL", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "500", price: 687, change: 43.9, percent: 0.64 },
  { symbol: "100", price: 254, change: 115, percent: 0.46 },
  { symbol: "V", price: 14.1, change: 0.02, percent: 0.14 },
  { symbol: "D1", price: 55, change: 1.5, percent: 2.8 },
  { symbol: "D2", price: 45.2, change: 0.75, percent: 1.69 },
  { symbol: "D3", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "AAPL", price: 270, change: -2.7, percent: -0.99 },
  { symbol: "aa", price: 32, change: 0.25, percent: 0.79 },
  { symbol: "bb", price: 270, change: -2.7, percent: -0.99 },
];

const Lab1 = () => {
  const [selected, setSelected] = useState(0);
  const listRef = useRef(null);

  // handle key events
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelected((prev) => Math.min(prev + 1, data.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelected((prev) => Math.max(prev - 1, 0));
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // auto-scroll into view
  useEffect(() => {
    const activeRow = listRef.current?.querySelector(".selected");
    activeRow?.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }, [selected]);

  const item = data[selected];

  return (
    <div className="stock-panel">
      <div className="stock-header">
        <h3>รายการ</h3>
        <div className="icons">
          <button>＋</button>
          <button>📊</button>
        </div>
      </div>

      <div className="stock-table" ref={listRef} tabIndex={0}>
        <table>
          <thead>
            <tr>
              <th>สัญญา</th>
              <th>ล่าสุด</th>
              <th>เปลี่ยน</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr
                key={i}
                className={`${item.percent < 0 ? "down" : "up"} ${
                  selected === i ? "selected" : ""
                }`}
                onClick={() => setSelected(i)}
              >
                <td>{item.symbol}</td>
                <td>{item.price}</td>
                <td>{item.change}</td>
                <td>{item.percent}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="stock-detail">
        <h2>{item.price.toFixed(2)} USD</h2>
        <p className={item.percent < 0 ? "down" : "up"}>
          {item.change > 0 ? "+" : ""}
          {item.change} ({item.percent}%)
        </p>
        <p>ตลาดปิด</p>
        <small>อัปเดตล่าสุด 07:59 GMT+7</small>
      </div>
    </div>
  );
};

export default Lab1;
